import * as React from 'react';
import { connect } from 'react-redux';

import { IRootState, ThunkDispatch } from '@src/domain';
import { resendVerificationEmail } from '@src/domain/User/UserActions';
import { UserStatuses } from '@src/domain/User/UserInterfaces';
import Box from '../legos/primitives/Box';
import Alert from '../legos/primitives/Alert';
import Text from '../legos/primitives/Text';
import Flex from '../legos/primitives/Flex';
import AsyncButton from '../legos/AsyncButton';

const mapStateToProps = (state: IRootState) => ({
  userPending: state.User.user && state.User.user.status === UserStatuses.pending,
});

const mapDispatchToProps = (dispatch: ThunkDispatch) => ({
  resendVerification: () => dispatch(resendVerificationEmail()),
});

interface IConfirmEmailPromptOwnprops {
  isPendingOwnership?: boolean;
}

const getVerificationMessage = (isPendingOwnership?: boolean) => (
  <Flex alignItems='center' flexWrap='wrap' justifyContent='space-between'>
    <Text lineHeight={1.5}>
      {isPendingOwnership ? 'You have a pending request to accept ownership of this organization, but y' : 'Y'}
      our email address has not been verified.
      Please follow the link in your email to verify your account.
    </Text>
  </Flex>
);

type ConfirmEmailPromptProps =
  ReturnType<typeof mapStateToProps> &
  ReturnType<typeof mapDispatchToProps> &
  IConfirmEmailPromptOwnprops;

const ConfirmEmailPrompt: React.FC<ConfirmEmailPromptProps> = ({
  userPending,
  resendVerification,
  isPendingOwnership,
}) => userPending ? (
  <Box maxWidth='900px' mb={3}>
    <Alert
      message={getVerificationMessage(isPendingOwnership)}
      type='warning'
    />
    <AsyncButton
      disableAfterSuccess
      onClickAsync={resendVerification}
      successButtonText='Verification email sent'
      type='button'
    >
      Resend verification email
    </AsyncButton>
  </Box>
) : null;

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmEmailPrompt);
